<template>
  <div class="tile">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({});
</script>

<style lang="scss" scoped>
.tile {
  background-color: #fff;
  box-shadow: 0.5em 1.125em 1.375em rgb(0 0 0 / 3%);
  border: 1px solid #f5f6fe;
  display: block;
  margin: 0 0 1.5rem 0;
  padding: 1em;
  position: relative;
  border-radius: 6px;
}
</style>
